import React from 'react'

import { AxesSuffix } from 'live/components/widget/ui/y-axis-config/y-axis-config-modal'
import i18n from 'live/services/i18n'

import NumericField from './NumericField'

type AxesSizeConfigProps = {
    value: number
    onChange: (value: number) => void
    label: string
}

const AxesSizeConfig: React.FunctionComponent<AxesSizeConfigProps> = (props: AxesSizeConfigProps) => {
    return (
        <NumericField className="dropdown-toggler--cancel-drag" minValueAllowed={0} maxValueAllowed={16} {...props}>
            <AxesSuffix>{i18n('axes')}</AxesSuffix>
        </NumericField>
    )
}

export default AxesSizeConfig
